import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PtbrCodesEditModal from './PtbrCodesEditModal';
import getLocale from '../../../i18n/getLocale';

class PtbrCodesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      modal_props: false,
      ptbr_codes: [],
      data_ptbr_code: [],
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.showModal = this.showModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.ptbr_codes)) {
      this.setState({ptbr_codes: newProps.ptbr_codes, modal_props: newProps.modal_props});
    }
  }
  
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      cdop: this.state.cdop,
      grpop: this.state.grpop,
      description: this.state.description,
      table_name: this.state.table_name,
      internal_use: this.state.internal_use,
    };

    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/referencias/ptbr/codigo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  ActionsButtons (cell, row) {    
    var botao = (
      <div className="btn-group">
        <button className="btn btn-primary btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
        <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
          <i className="fa fa-fw fa-trash"></i>
        </button>
      </div>
    );

    return botao;
  }

  delete (event) {
    var ptbr_code_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.deletarCodigo);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/referencias/ptbr/codigo/' + ptbr_code_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(ptbr_code_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  deleteRow(ptbr_code_id) {
    var data = this.state.ptbr_codes;
    data.map(function(dado, index){
      if (dado.id == ptbr_code_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }


  showModal(event) {
    var self = this;
    var ptbr_code_id = event.currentTarget.value;

    var data = self.state.ptbr_codes;
    data.map(function(dado, index){
      if (dado.id == ptbr_code_id) {
        self.setState({
          data_ptbr_code: dado,
          modal_props: true,
        });
      }
    });
  }



  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.CDOP}:</label>
          <input type="text" name="cdop" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.placeholder.CDOP} value={this.state.cdop} onChange={this.handleChange.bind(this, 'cdop')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.GRPOP}:</label>
          <input type="text" name="grpop" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.placeholder.GRPOP} value={this.state.grpop} onChange={this.handleChange.bind(this, 'grpop')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.Descricao}:</label>
          <input type="text" name="description" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.placeholder.Descricao} value={this.state.description} onChange={this.handleChange.bind(this, 'description')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.Tabela}:</label>
          <input type="text" name="table_name" className="form-control" placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.placeholder.NomeDaTabela} value={this.state.table_name} onChange={this.handleChange.bind(this, 'table_name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.UsoInterno}:</label>
          <Select
            className="form-field-name"
            name="internal_use"
            value={this.state.internal_use}
            searchable={true}
            placeholder={this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.placeholder.SelecioneOUsoInterno}
            onChange={this.handleSelectChange.bind(this, 'internal_use')}
            options={[
              {value: 1, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoDePartida},
              {value: 2, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoDeDecolagem},
              {value: 3, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoDePouso},
              {value: 4, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoDeCorte},
              {value: 5, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoDeVoo},
              {value: 6, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoDeAtraso},
              {value: 7, label: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.opcoesUsoInterno.CodigoPadraoDeVoo},
            ]}
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-inline btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.formulario.botaoAdicionarCodigoPTBR}</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.ptbr_codes} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.semCodigosPTBR}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.ID}</TableHeaderColumn>
    <TableHeaderColumn dataField="cdop" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.CDOP}</TableHeaderColumn>
    <TableHeaderColumn dataField="grpop" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.GRPOP}</TableHeaderColumn>
    <TableHeaderColumn dataField="description" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.Descricao}</TableHeaderColumn>
    <TableHeaderColumn dataField="table_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.Tabela}</TableHeaderColumn>
    <TableHeaderColumn dataField="internal_use_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.UsoInterno}</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.PTBR.ReferenciasPTBR.tabCodigosDaExportacaoXML.tabela.Acoes}</TableHeaderColumn>

  </BootstrapTable>
  <PtbrCodesEditModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} data_ptbr_code={self.state.data_ptbr_code} refreshTable={self.props.refreshTable} />
</div>
    );
  }
}

export default PtbrCodesTab;



// WEBPACK FOOTER //
// ./src/Components/Ptbr/Elements/PtbrCodesTab.js